const dev = {
  API_ENDPOINT_URL: 'http://localhost:3013/api',
  WS_ENDPOINT_URL: 'ws://localhost:3013/ws/'
};

const prod = {
  API_ENDPOINT_URL: 'https://hoc.codeforce.ca/api',
  WS_ENDPOINT_URL: 'wss://hoc.codeforce.ca/ws/'
};

const test = {
  API_ENDPOINT_URL: '/api',
  WS_ENDPOINT_URL: 'ws://localhost:5000/ws/'
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
